import { initializeWebMonitoring } from "@kindtutor/web-observability";

initializeWebMonitoring({
  application: "school",
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_APP_ENV?.trim() || import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION,
});
